import React from 'react';
import { connect } from 'react-redux';
import PapaParse from 'papaparse/papaparse.min.js';
import axios from 'axios';
import { toast } from 'react-toastify';
import { getModelData } from '../../Redux/Actions/modelsDataActions';
import { toggleLoading } from '../../Redux/Actions/Loading';

class CSVReader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hdrs: {},
    };
    this.fileInput = React.createRef();
  }
  hdrs = {}; // not swapped

  componentDidMount() {
    axios
      .get('/api/v1/configs')
      .then(resp => resp.data.configs)
      .then(configs => {
        this.hdrs = configs;
        this.setState({ hdrs: this.swap(configs) });
      })
      .catch(e => {
        toast.error(`Impossible d'obtenir les configurations`);
      });
  }

  swap = json => {
    let ret = {};
    for (let key in json) {
      ret[json[key].value] = json[key];
    }
    return ret;
  };

  handleChange = files => {
    const { onToggleLoading } = this.props;
    if (files.length) {
      onToggleLoading();
      const file = files[0];

      PapaParse.parse(file, {
        header: true,
        skipEmptyLines: true,
        encoding: 'iso-8859-1',
        beforeFirstChunk: chunk => {
          const rows = chunk.split(/\r\n|\r|\n/);
          let headings = rows[0].split(';');
          headings.pop();
          headings = this.updateHeaders(headings);
          rows[0] = headings.join(';');
          return rows.join('\n');
        },
        complete: this.updateData,
      });
    }
  };

  updateData = result => {
    const { onGetModelData, onToggleLoading } = this.props;
    axios
      .post('api/v1/jobs', { jobs: result.data, hdrs: this.hdrs })
      .then(resp => resp.data.count)
      .then(count => {
        this.fileInput.value = '';
        onGetModelData('clients');
        onToggleLoading();
        alert(`${count} clients ajoutés`);
      })
      .catch(e => {
        onToggleLoading();
        toast.error(`Impossible d'importer les travaux`);
      });
  };

  updateHeaders = array => {
    const { hdrs } = this.state;
    const headers = [...array];

    headers.forEach((header, index) => {
      if (hdrs[header]) {
        headers[index] = hdrs[header].key;
      }
    });

    return headers;
  };

  render() {
    return (
      <div className="button-pane csv-upload">
        <input
          id="jobs_file"
          type="file"
          className="btn btn-default"
          accept=".csv"
          onChange={e => this.handleChange(e.target.files)}
          ref={ref => (this.fileInput = ref)}
        />
        {/* <button className="btn btn-primary">Soumettre</button> */}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  onToggleLoading: () => dispatch(toggleLoading()),
  onGetModelData: data => dispatch(getModelData(data)),
});

export default connect(
  null,
  mapDispatchToProps,
)(CSVReader);
